import { createMomentSchedule } from './create'
import { deleteMomentSchedule } from './delete'
import { resourceObject } from './resourceObject'
import { updateMomentSchedule } from './update'

export const momentSchedules = {
  clientResource: resourceObject,
  create: createMomentSchedule,
  delete: deleteMomentSchedule,
  update: updateMomentSchedule,
}
